import $ from 'jquery';

$('.toggle-post-type').on('click', function (e) {
	e.preventDefault();
	$('.toggle-post-type').removeClass('target-group__button-buttons--active');
	$('#events-tab, #projects-tab, #news-tab').addClass('hide');
	var target = $(this).data('target');
	$('#' + target).removeClass('hide');
	$(this).addClass('target-group__button-buttons--active');
	Foundation.reInit('equalizer');

});